import useFilePaste from './useFilePaste';

export interface UseImagePasteOptions {
  onImagePaste: (file: File) => void | Promise<void>;
}

/**
 * Hook to handle pasting images from clipboard
 * Sets up a global paste event listener that processes image files only
 * Uses useFilePaste internally and filters for image files
 */
export default function useImagePaste({onImagePaste}: UseImagePasteOptions) {
  useFilePaste({
    onFilePaste: async (file) => {
      if (file.type.startsWith('image/')) {
        await onImagePaste(file);
      }
    },
  });
}
